export const en = {
  brand: "OrderHub",
  buttons: {
    save: "Save",
    saving: "Saving...",
    cancel: "Cancel",
    reload: "Reload page",
    delete: "Delete",
    retry: "Retry",
    close: "Close",
    create: "Create",
    sending: "Sending...",
    edit: "Edit",
    reset: "Reset",
  },
  formLabels: {
    email: "Email",
    role: "Role",
    team: "Team",
    status: "Status",
  },
  errors: {
    unexpected: "An unexpected error occurred. Our team has been notified.",
    somethingWentWrong: "Something went wrong",
    unexpectedShort: "An unexpected error occurred. Please try again.",
    unknownError: "Unknown error",
  },
  empty: {
    noResults: "No results found",
  },
  divider: {
    or: "or",
  },
  filter: {
    all: "All",
  },
  status: {
    enabled: "Enabled",
    disabled: "Disabled",
    loading: "Loading...",
  },
  select: {
    placeholder: "Select {{label}}",
    loading: "Loading {{label}}...",
  },
  priority: {
    high: "High",
    medium: "Medium",
    low: "Low",
  },
  pagination: {
    ariaLabel: "pagination",
    previous: "Previous",
    next: "Next",
    ariaPrevious: "Go to previous page",
    ariaNext: "Go to next page",
    srMorePages: "More pages",
    showing: "Showing",
    of: "of",
  },
  dialog: {
    srClose: "Close",
  },
  search: {
    placeholderWithCustomers: "Search by Order reference and customer name",
    placeholderDefault: "Search by Order reference",
    clear: "Clear",
    typeAtLeast2: "Type at least 2 characters",
    noResults: "No results found",
    groupCustomers: "Customers",
    groupActivities: "Activities",
  },
  copyToClipboard: "Copy to clipboard",
  copied: "Copied!",
  help: {
    needHelpPrefix: "Need help? ",
    contactSupport: "Contact support",
  },
  upgrade: {
    upgradeToPlan: "Upgrade to {{planName}}",
  },
} as const;
